/* 
// JTM - RS  
// product builder calc scripts - Pillow Builder
*/
//waitForElm('.product.js-product > .product-info.cd-builder-ready', true).then((elm) => {

///////////////////////////////////////////////////////////
// calculate total fabric yards - Cushion Builder (all cushion builder types)
//function calculateCushionFabricYardage(inputProductPillowType, inputProductWidth, inputProductLength, inputProductThickness, inputProductDiameter, inputMaterialFabricWidth, inputProductQuantity) {
function calculatePillowFabricYardage() {

    let value = "false";
    //if(window.console){console.log("calculatePillowFabricYardage triggered"); }
    let inputProductType = $q('._cd--product-type input[type="radio"]:checked').next('label.label').find('span').text().trim();
    let inputProductQuantityValue = $q("quantity-input .qty-input__input.input").val();    
    let inputProductOrientation = 'Width';                
    // fabric width - input
    let inputFabricWidthValue = $q("._cd--fabric-width input.input-text").val();                
    // fabric design - input
    let inputFabricDesignValue = $q("._cd--fabric-design input.input-text").val();
    // welt inputs
    let inputWeltFabricWidthValue = "";
    let inputWeltFabricDesignValue = "";
    let weltChecked = false;
    
    if(document.querySelector('._cd--welt input[data-cd-option-name="cd--welt-double"]:checked') !== null){ 
        weltChecked = true;
        // welt width - input
        inputWeltFabricWidthValue = $q("._cd--welt-width input.input-text").val();                    
        // welt design - input
        inputWeltFabricDesignValue = $q("._cd--welt-fabric-design input.input-text").val();
    }

    ////////////
    
    // is square shape
    let squareChecked = (document.querySelector('._cd--shape input[data-cd-option-name="cd--shape-square"]:checked') !== null);
    // is trapezoid
    //let trapezoidChecked = (document.querySelector('._cd--shape input[data-cd-option-name="cd--shape-trapezoid"]:checked') !== null);
    // is round shape
    //let roundChecked = (document.querySelector('._cd--shape input[data-cd-option-name="cd--shape-round"]:checked') !== null);
    

    // size width - input
    let inputProductWidthValue = $q('._cd--width input').val();
    let inputProductWidthCheck = (parseFloat(inputProductWidthValue) !== "" && parseFloat(inputProductWidthValue) !== 0);

    // size height - input
    let inputProductHeightValue = $q('._cd--height input').val();
    //console.log('inputProductLengthValue',inputProductLengthValue);
    let inputProductHeightCheck = (parseFloat(inputProductHeightValue) !== "" && parseFloat(inputProductHeightValue) !== 0);

    // size length - input
    let inputProductLengthValue = $q('._cd--length input').val();
    //console.log('inputProductLengthValue',inputProductLengthValue);
    let inputProductLengthCheck = (parseFloat(inputProductLengthValue) !== "" && parseFloat(inputProductLengthValue) !== 0);

    // size diamter - input 
    let inputProductDiameterValue = $q('._cd--diameter input').val();
    let inputProductDiameterCheck = (parseFloat(inputProductDiameterValue) !== "" && parseFloat(inputProductDiameterValue) !== 0);

    // size seat thickness - input
    //let inputProductSeatThicknessValue = $q('.cd--thickness select').val();
    //let inputProductSeatThicknessCheck = (inputProductSeatThicknessValue !== "-- inches --" && parseFloat(inputProductSeatThicknessValue) !== 0);

    // get thickness
    let inputProductThicknessValue = $q('._cd--thickness input[type="checkbox"]').next('label.label').find('span').text().trim();
    let inputProductThicknessCheck = (parseFloat(inputProductThicknessValue) !== "" && parseFloat(inputProductThicknessValue) !== 0);

    ////////////////////////////

    let passedRequiredArgsAsPillow = false;

    let bolsterPillowPassedArgsCheck = (
        (inputProductType === "Bolster") && 
        (inputProductLengthValue !== "") && 
        (inputProductDiameterValue !== "") && 
        (inputProductLengthCheck) && 
        (inputProductDiameterValue) && 
        (parseFloat(inputProductLengthValue) !== 0) && 
        (parseFloat(inputProductDiameterValue) !== 0)
    );


    let otherPillowPassedArgsCheck = (
        (inputProductWidthValue !== "") && 
        (inputProductHeightValue !== "") && 
        (inputProductThicknessValue !== "") && 
        (inputProductWidthCheck) && 
        (inputProductHeightCheck) && 
        (inputProductThicknessCheck) && 
        (parseFloat(inputProductWidthValue) !== 0) && 
        (parseFloat(inputProductHeightValue) !== 0) && 
        (parseFloat(inputProductThicknessValue) !== 0)
    );

    if (bolsterPillowPassedArgsCheck || otherPillowPassedArgsCheck) {
        passedRequiredArgsAsPillow = true;
    }

    // if(window.console){
        // console.log('passedRequiredArgsAsPillow', passedRequiredArgsAsPillow);
        // console.log("inputProductWidthValue",inputProductWidthValue);
        // console.log("inputProductHeightValue",inputProductHeightValue);
        // console.log("inputProductLengthValue",inputProductLengthValue);
        // console.log("inputProductThicknessValue",inputProductThicknessValue);
        // console.log("inputProductWidthCheck",inputProductWidthCheck);
        // console.log("inputProductLengthCheck",inputProductLengthCheck);
        // console.log("inputProductThicknessCheck",inputProductThicknessCheck);
    //} 

    if (passedRequiredArgsAsPillow == true && inputFabricDesignValue !== "" && inputProductQuantityValue !== "") {
        //console.log('run pillow');
        value = true;
    }
    
    
    // size and fabric input field selector refernce goes here

    ///////////////////////////////////////////
    // START calculation
    if(value == true){
  
        let edgeAllowance = 0.5;
        let quantity = inputProductQuantityValue;
        let include = "Full Cushion";
        let zipperSliderQty = inputProductQuantityValue;
        let fabricWidth = parseFloat(inputFabricWidthValue);
        let orientation = "Width";

        let numOfPlates;
        let plaqueLength;
        let boxingWidth;
        let boxingLength;
        let plaquewidth;
        let binding;
        let StraightCutAdditionalFabric;
        let bindingSource;
        let inchesPlate;
        let inchesPlaque;
        let inchesBoxing;
        let howManyPlatesCanFit;
        let howManyPlateSections;
        let inchesNeeded;
        let plates;
        let totalPlate;
        let neededYardsPrecise;
        let neededYardsEstimated;

        let finishedwidth;
        let finishedlength;
        let thickness;
        let calculatedFabricYardsNeeded = 0;

        if (inputProductType === 'Bolster') {
            //console.log(inputProductType + '|length is ' + inputProductLength + '|diameter is ' + inputProductDiameter);
            finishedwidth = parseFloat(inputProductDiameterValue);
            finishedlength = parseFloat(inputProductLengthValue);
            thickness = inputProductDiameterValue;

        } else {
            //console.log(inputProductType + '|width is ' + inputProductWidth + '|height is ' + inputProductHeight + '|thickness is ' + inputProductThickness);
            finishedwidth = parseFloat(inputProductWidthValue);
            finishedlength = parseFloat(inputProductHeightValue);
            thickness = inputProductThicknessValue;
        }

        let foamWidth = finishedwidth + edgeAllowance;
        let foamLength = finishedlength + edgeAllowance;

        switch (include) {
            case "Full Cushion":

                numOfPlates = parseInt(quantity) * 2;
                plaqueLength = Math.round(parseInt(quantity) * (parseFloat(finishedlength) + 2));
                boxingWidth = parseFloat(thickness) + edgeAllowance;
                boxingLength = Math.round(
                    ((parseInt(quantity) * (((parseFloat(finishedwidth) * 2) + parseFloat(finishedlength)) + (4 * edgeAllowance)))) * 1.05
                );
                plaquewidth = boxingWidth + 1.25;
                binding = Math.round(
                    2 * (parseInt(quantity) * ((parseFloat(finishedwidth) + parseFloat(finishedlength)) * 2))
                ) * 1.05;
                StraightCutAdditionalFabric = Math.round(binding / fabricWidth) * 1.75;
                bindingSource = Math.round(Math.sqrt(binding * 1.75) + 2);

                if (orientation === 'Width') {
                    howManyPlatesCanFit = Math.floor(fabricWidth / parseFloat(finishedlength));
                    if (howManyPlatesCanFit < 1) {
                        howManyPlatesCanFit = fabricWidth / parseFloat(finishedlength);
                    }
                    howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                    inchesNeeded = howManyPlateSections * parseFloat(finishedwidth);
                } else {
                    howManyPlatesCanFit = Math.floor(fabricWidth / parseFloat(finishedwidth));
                    if (howManyPlatesCanFit < 1) {
                        howManyPlatesCanFit = fabricWidth / parseFloat(finishedwidth);
                    }
                    howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                    inchesNeeded = howManyPlateSections * parseFloat(finishedlength);
                }

                inchesPlate = inchesNeeded;
                inchesNeeded += Math.ceil(plaqueLength / fabricWidth) * plaquewidth;
                inchesPlaque = inchesNeeded;
                inchesNeeded += Math.ceil(boxingLength / fabricWidth) * boxingWidth;
                inchesBoxing = inchesNeeded;

                break;

            case "One Plate & Boxing":

                numOfPlates = parseInt(quantity) * 1;
                plaqueLength = Math.round(parseInt(quantity) * (parseFloat(finishedlength) + 1.25));
                boxingWidth = parseFloat(thickness) + edgeAllowance;
                boxingLength = Math.round(
                    ((parseInt(quantity) * (((parseFloat(finishedwidth) * 2) + parseFloat(finishedlength)) + (4 * edgeAllowance)))) * 1.05
                );
                plaquewidth = boxingWidth + 1.25;
                binding = Math.round(1 * (parseInt(quantity) * ((parseFloat(finishedwidth) + parseFloat(finishedlength)) * 2))) * 1.05;
                StraightCutAdditionalFabric = Math.round(binding / fabricWidth) * 1.75;
                bindingSource = Math.round(Math.sqrt(binding * 1.75) + 2);

                if (orientation === 'Width') {
                    howManyPlatesCanFit = Math.floor(fabricWidth / parseFloat(finishedlength));
                    if (howManyPlatesCanFit < 1) {
                        howManyPlatesCanFit = fabricWidth / parseFloat(finishedlength);
                    }
                    howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                    inchesNeeded = howManyPlateSections * parseFloat(finishedwidth);
                } else {
                    howManyPlatesCanFit = Math.floor(fabricWidth / parseFloat(finishedwidth));
                    if (howManyPlatesCanFit < 1) {
                        howManyPlatesCanFit = fabricWidth / parseFloat(finishedwidth);
                    }
                    howManyPlateSections = Math.ceil(numOfPlates / howManyPlatesCanFit);
                    inchesNeeded = howManyPlateSections * parseFloat(finishedlength);
                }

                inchesPlate = inchesNeeded;
                inchesNeeded += Math.ceil(plaqueLength / fabricWidth) * plaquewidth;
                inchesPlaque = inchesNeeded;
                inchesNeeded += Math.ceil(boxingLength / fabricWidth) * boxingWidth;
                inchesBoxing = inchesNeeded;

                break;
        }

        plates = numOfPlates === 1 ? " plate" : " plates";
        totalPlate = numOfPlates + plates;
        neededYardsPrecise = (inchesNeeded / 36);
        neededYardsEstimated = self.roundUpToNearest(neededYardsPrecise, 0.5);
        calculatedFabricYardsNeeded = neededYardsEstimated;

        //if(window.console){
            //console.log('neededYardsPrecise ' + neededYardsPrecise);
            //console.log('neededYardsEstimated ' + neededYardsEstimated);
            //console.log("Pillow - ", calculatedFabricYardsNeeded);
        //}
        return calculatedFabricYardsNeeded;

    } else {
        return "false";
    }
};

//}); // end wait for ready